import React, { useContext } from "react";
import ReactDOM from "react-dom";

import { faSpinnerThird } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFeatureValue } from "@growthbook/growthbook-react";

import { AppContext } from "~/common";
import { dispatchAnalyticsTrack } from "~/lib/segment";
import Switch from "~/ui/Switch/Switch";
import { useUXSimplificationFeature } from "~/uxSimplificationFeature";
import { useTourContext } from "~/welcomeChecklist/TourController";

import { Divider, Label, Left, Right, Row, SettingsPageSubtitle, SettingsPageTitle, SubLabel } from "./shared";

import styles from "./EarlyAccess.module.css";

export default function EarlyAccess() {
	const { user } = useContext(AppContext);
	const { toggleUXSimplification } = useUXSimplificationFeature();
	const feedbackLink = useFeatureValue("early-access-feedback-link", "");

	React.useEffect(() => {
		dispatchAnalyticsTrack("[User Settings] Viewed Early Access tab");
	}, []);

	return (
		<div className={styles.main}>
			<SettingsPageTitle>Early access</SettingsPageTitle>
			<SettingsPageSubtitle>Manage your preferences</SettingsPageSubtitle>
			<Divider />
			<Row>
				<Left>
					<Label>Try the new Fellow interface</Label>
					<SubLabel>
						Get early access to our new look and feel - only affects your view. You can switch back anytime.
					</SubLabel>
				</Left>
				<Right>
					<Switch size="small" checked={user?.uxSimplificationEnabled} onCheckedChange={toggleUXSimplification} />
				</Right>
			</Row>
			{user?.uxSimplificationEnabled && (
				<div className={styles.feedbackBanner}>
					Your input helps shape the final version. <a href={feedbackLink}>Share your feedback.</a>
				</div>
			)}
		</div>
	);
}

export function EarlyAccessLoadingSpinner({ onClose }: { onClose: () => void }) {
	const { startTour } = useTourContext();

	// We want to show a fake loading state before the Early Access Tour is shown to the user, hence the setTimeout.
	React.useEffect(() => {
		const timeout = setTimeout(() => {
			startTour("EARLY_ACCESS_TOUR");
			onClose();
		}, 2000);

		return () => {
			clearTimeout(timeout);
		};
	}, [startTour, onClose]);

	return ReactDOM.createPortal(
		<div className={styles.loadingContainer}>
			<FontAwesomeIcon icon={faSpinnerThird} spin className={styles.loadingSpinner} />
		</div>,
		document.body,
	);
}
